<div class="layout-wrapper" [ngClass]="containerClass">
  <pegasus-topbar></pegasus-topbar>
  <div class="layout-sidebar">
    <pegasus-sidebar></pegasus-sidebar>
  </div>
  <div class="layout-main-container">
    <div class="layout-main">
        <router-outlet></router-outlet>
    </div>
  </div>
  <div class="layout-mask"></div>
</div>
